import { setLocale } from "yup";
import { appI18n } from "./i18n";

const t = (key: string, values?: Record<string, unknown>) => appI18n.t(`validation:yup.${key}`, values);

setLocale({
    mixed: {
        default: () => t("mixed.invalid"),
        required: () => t("mixed.required"),
        oneOf: ({ values }: { values: string }) => t("mixed.oneOf", { values }),
        notOneOf: ({ values }: { values: string }) => t("mixed.notOneOf", { values }),
        notType: () => t("mixed.notType"),
        defined: () => t("mixed.defined"),
    },
    string: {
        length: ({ length }: { length: number }) => t("string.length", { length }),
        min: ({ min }: { min: number }) => t("string.min", { min }),
        max: ({ max }: { max: number }) => t("string.max", { max }),
        matches: () => t("string.matches"),
        email: () => t("string.email"),
        url: () => t("string.url"),
        uuid: () => t("string.uuid"),
        trim: () => t("string.trim"),
        lowercase: () => t("string.lowercase"),
        uppercase: () => t("string.uppercase"),
    },
    number: {
        min: ({ min }: { min: number }) => t("number.min", { min }),
        max: ({ max }: { max: number }) => t("number.max", { max }),
        lessThan: ({ less }: { less: number }) => t("number.lessThan", { less }),
        moreThan: ({ more }: { more: number }) => t("number.moreThan", { more }),
        positive: () => t("number.positive"),
        negative: () => t("number.negative"),
        integer: () => t("number.integer"),
    },
    date: {
        min: ({ min }: { min: Date | string }) => t("date.min", { min }),
        max: ({ max }: { max: Date | string }) => t("date.max", { max }),
    },
    boolean: {
        isValue: () => t("boolean.isValue"),
    },
    object: {
        noUnknown: () => t("object.noUnknown"),
    },
    array: {
        min: ({ min }: { min: number }) => t("array.min", { min }),
        max: ({ max }: { max: number }) => t("array.max", { max }),
        length: ({ length }: { length: number }) => t("array.length", { length }),
    },
});
